import {Enumify} from "enumify-ts";

class InputType extends Enumify<InputType>() {

    static TEXT = new InputType();
    static DATE = new InputType();
    static NONE = new InputType();
    static _ = InputType._closeEnum();

}

export default InputType;
